import { URL } from "../../api/Api";
import { CHATBOT } from "../Action";
import { catchError, GET, POST } from "../axios/Axios";

export const ChatBotCall = (payload) => {
  return async (dispatch) => {
    try {
      const response = await POST(`${URL}/chatbot/chat/`, payload, {});
      dispatch({ type: CHATBOT.chatBot, data: response.data });
      return response.data;
    } catch (error) {
      throw catchError(error);
    }
  };
};

export const ChatBotGetCall = async (job_id, params = {}) => {
  try {
    const response = await GET(
      `${URL}/chatbot/chat/messages/${job_id}`,
      params
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const CandidateChatBot = (payload) => {
  return async (dispatch) => {
    try {
      const response = await POST(`${URL}/chatbot/chat/resume/`, payload, {});
      dispatch({ type: CHATBOT.candidatechatBot, data: response.data });
      return response.data;
    } catch (error) {
      throw catchError(error);
    }
  };
};

export const CandidateChatBotGetCall = async (job_id) => {
  try {
    const response = await GET(
      `${URL}/chatbot/chat/resume/messages/${job_id}`,
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const CompareChatBotGetCall = async (job_id, params) => {
  try {
    const response = await GET(
      `${URL}/chatbot/chat/compare/messages/${job_id}`,
      params
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const CompareChatBot = (payload) => {
  return async (dispatch) => {
    try {
      const response = await POST(`${URL}/chatbot/chat/compare`, payload, {});
      dispatch({ type: CHATBOT.comparechatBot, data: response.data });
      return response.data;
    } catch (error) {
      throw catchError(error);
    }
  };
};

export const KlarityChatBotCall = async (payload) => {
  try {
    const response = await POST(
      `https://dev-seekql.talairo.ai/query`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const SupportCall = async (payload) => {
  try {
    const response = await POST(`${URL}/chatbot/chat/support`, payload, {});
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const SupportGetCall = async (id) => {
  try {
    const response = await GET(
      `${URL}/chatbot/chat/support/messages/${id}`,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

//KlarityChatBot

export const KlarityChatBotPOST = async (payload) => {
  try {
    const response = await POST(`${URL}/chatbot/klarity-chat/`, payload, {});
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};
